export type BusinessDateTime = { date: string; time: string };

/**
 * Wall-clock date (`yyyy-MM-dd`) and time (`HH:mm`) in the given zone — the one the backend evaluates
 * order deadlines in, whatever zone the user's device is set to.
 */
export const toBusinessDateTime = (
  date: Date,
  timeZone: string,
): BusinessDateTime => {
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  });
  const parts: Partial<Record<Intl.DateTimeFormatPartTypes, string>> = {};
  formatter.formatToParts(date).forEach(({ type, value }) => {
    parts[type] = value;
  });

  return {
    date: `${parts.year}-${parts.month}-${parts.day}`,
    time: `${parts.hour}:${parts.minute}`,
  };
};
